import styled from 'styled-components';
import { Link, Text, TextButton } from '@amzn/storm-ui';
import { PAGE_LAYOUT_TYPE } from 'src/app/slice';

export const FooterWrapper = styled.div<{ pageLayoutType: PAGE_LAYOUT_TYPE }>`
  box-sizing: border-box;
  text-align: center;
  padding: 18px;
  font-size: 12px;
  line-height: 15px;
  font-smooth: subpixel-antialiased;

  ${(props) =>
    [PAGE_LAYOUT_TYPE.STANDARD, PAGE_LAYOUT_TYPE.INTERNAL_STANDARD].includes(
      props.pageLayoutType,
    )
      ? `
        margin-inline-start: 60px;
      `
      : ''};
`;

export interface FooterLinksProps {
  isVertical: boolean | undefined;
}

export const FooterLinks = styled('div')<FooterLinksProps>`
  display: inline;

  ${(props) =>
    props.isVertical
      ? `
    display: flex;
    flex-direction: column;
  `
      : ''};
`;

export const FooterLink = styled(Link)`
  &&& {
    color: ${({ theme }) => theme.palette.black};
  }

  text-decoration: none;
  margin-left: 18px;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const FooterLinkMobile = styled(Link)`
  &&& {
    color: ${({ theme }) => theme.palette.blue[700]};
  }

  line-height: 2.25;
  margin: 0 9px;

  // The last item should be a block element

  &:last-child {
    display: block;
  }
`;

export const Copyright = styled(Text)`
  color: ${({ theme }) => theme.palette.emperor};
  display: inline-block;
  font-size: inherit;
`;

// tertiary no longer available in palette. Using equivalent color #5C687C
// https://code.amazon.com/packages/StormUI/blobs/c0a237ab9a450d2caf309080f9910e3b839b62df/--/packages/storm-ui/src/theme/base/color.ts#L48
export const CopyrightMobile = styled(Text)`
  color: ${({ theme }) => theme.palette.gray[700]};
`;

export const MobileFooterWrapper = styled.div`
  text-align: center;
  background-color: ${({ theme }) => theme.palette.gray[25]};
  padding-top: 18px;
`;

export const MobileToggleMode = styled(TextButton)`
  font-size: 15px;
  margin-bottom: 8px;
`;

export const MobileLinkWrapper = styled.div`
  text-align: center;
  display: inline-block;
  margin-bottom: 20px;
  padding: 0 16px;
`;
export const DesktopToggleWrap = styled.div`
  font-size: 40px;
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
`;

export const PeekabooStickyTabWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 2;
`;
